import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';











export const getBadgeWrapperStyle = ({
  color = 'info',
  variant = 'contained',
  theme,
}



) => ({
  backgroundColor:
    variant === 'contained' ? theme.palette[color].dark : 'transparent',
  border:
    variant === 'contained' ? 'none' : `1px solid ${theme.palette[color].dark}`,
  color:
    variant === 'contained'
      ? theme.palette[color].contrastText
      : theme.palette[color].dark,
  padding: '4px 8px',
  width: 'fit-content',
  borderRadius: 4,
});

export function Badge({ color = 'info', variant = 'contained' }) {
  const theme = useTheme();

  return (
    React.createElement(Box, { style: getBadgeWrapperStyle({ color, variant, theme }),}
      , React.createElement(Typography, { variant: "body2", style: { fontWeight: 700 },}, "Information"

      )
    )
  );
}
